import { matchObjsShape } from '@agritask/js-utils/libs/object_utils';
import { axiosGet } from '../vue/utils/api';
const versionsResponse = {
    'module-versions': {
        modules: [],
    },
    reportingModulesVersions: {
        list: [],
        rptDefMetadataVersion: '',
    },
};
export async function getAgritaskModulesVersions(prefix) {
    const response = await axiosGet(`${prefix}rest/version/v1/modules`);
    return matchObjsShape(versionsResponse, response);
}
export async function getVersionNumber(prefix) {
    const response = await getAgritaskModulesVersions(prefix);
    const version = response['module-versions'].modules.find((m) => m.module === 'web_ui')?.version;
    return version ?? '-';
}
